export default __webpack_public_path__ + "static/media/hisense.c14848be.svg";